import layout from '@/layout'
const meta = { auth: true }

export default {
  path: '/resourceManagement',
  name: 'resourceManagement',
  meta,
  component: layout,
  children: ((pre) => [
    {
      path: 'designElements/designElementsCategory',
      name: `${pre}designElementsCategory`,
      meta: {
        ...meta,
        cache: true,
        title: '素材类别设置',
        head: true,
        funcID: 'T000301',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/designElements/category')
    },
    {
      path: 'designElements/designElementsDictionary',
      name: `${pre}designElementsDictionary`,
      meta: {
        ...meta,
        cache: true,
        title: '素材属性配置',
        head: true,
        funcID: 'T000302',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/designElements/dictionary')
    },
    {
      path: 'designElements/designElementsInputTemplate',
      name: `${pre}designElementsInputTemplate`,
      meta: {
        ...meta,
        cache: true,
        title: '素材录入模板配置',
        head: true,
        funcID: 'T000303',
        PID: 'T00'
      },
      component: () =>
        import(
          '@/views/digital/resourceManagement/designElements/inputTemplate'
        )
    },
    {
      path: 'designElements/designElementsTag',
      name: `${pre}designElementsTag`,
      meta: {
        ...meta,
        cache: true,
        title: '素材标签设置',
        head: true,
        funcID: 'T000304',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/designElements/tag')
    },
    {
      path: 'designElements/designElementsInfo',
      name: `${pre}designElementsInfo`,
      meta: {
        ...meta,
        cache: true,
        title: '素材资料管理',
        head: true,
        funcID: 'T000305',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/designElements/info')
    },
    {
      path: 'designElements/designElementsInfoUpdate/:pageType/:deCode',
      name: `${pre}designElementsInfoUpdate`,
      meta: {
        ...meta,
        cache: true,
        title: '素材资料修改',
        funcID: 'T000305',
        PID: 'T00'
      },
      component: () =>
        import(
          '@/views/digital/resourceManagement/designElements/info/components/detail'
        )
    },
    {
      path: 'research/researchDictionary',
      name: `${pre}research-dictionary`,
      meta: {
        ...meta,
        cache: true,
        title: '资源属性设置',
        head: true,
        funcID: 'T000401',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/research/dictionary')
    },
    {
      path: 'research/researchInputTemplate',
      name: `${pre}researchInputTemplate`,
      meta: {
        ...meta,
        cache: true,
        title: '资源录入模板设置',
        head: true,
        funcID: 'T000402',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/research/inputTemplate')
    },
    {
      path: 'research/researchTag',
      name: `${pre}researchTag`,
      meta: {
        ...meta,
        cache: true,
        title: '资源标签设置',
        head: true,
        funcID: 'T000403',
        PID: 'T00'
      },
      component: () => import('@/views/digital/resourceManagement/research/tag')
    },
    {
      path: 'research/researchInfo',
      name: `${pre}researchInfo`,
      meta: {
        ...meta,
        cache: true,
        title: '市场情报维护',
        head: true,
        funcID: 'T000404',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/research/info')
    },
    {
      path: 'research/researchInfoUpdate/:pageType/:resCode?',
      name: `${pre}researchInfoUpdate`,
      meta: {
        ...meta,
        cache: true,
        title: '市场情报维护修改',
        funcID: 'T000404',
        PID: 'T00'
      },
      component: () =>
        import(
          '@/views/digital/resourceManagement/research/info/components/detail'
        )
    },
    {
      path: 'research/fabric',
      name: `${pre}fabric`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'T000405',
        PID: 'T00',
      },
      component: () => import('@/views/digital/resourceManagement/research/fabric'),
    },
    {
      path: 'research/bizDemand',
      name: `${pre}bizDemand`,
      meta: {
        ...meta,
        cache: true,
        title: '调研面料需求',
        head: true,
        funcID: 'T000406',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/research/bizDemand')
    },
    {
      path: 'research/fabricPurchase',
      name: `${pre}fabricPurchase`,
      meta: {
        ...meta,
        cache: true,
        title: '调研面料采购',
        head: true,
        funcID: 'T000407',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/research/fabricPurchase')
    },
    {
      path: 'research/fabricPurchase/:pageType/:code?',
      name: `${pre}fabricPurchase-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { resFabricPurchaseNo = '' } = $route.query || {}
          if (!resFabricPurchaseNo) return '调研面料采购 | New'
          return `调研面料采购 | ${resFabricPurchaseNo}`
        },
        funcID: 'T000407',
        PID: 'T00',
      },
      component: () => import('@/views/digital/resourceManagement/research/fabricPurchase/detail'),
    },
    {
      path: 'research/fabric/:pageType/:code?',
      name: `${pre}research-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { resFabricRecordNo = '' } = $route.query || {}
          if (!resFabricRecordNo) return '面料调研记录 | New'
          return `面料调研记录 | ${resFabricRecordNo}`
        },
        funcID: 'T000405',
        PID: 'T00',
      },
      component: () => import('@/views/digital/resourceManagement/research/fabric/detail'),
    },
    {
      path: 'scm/scmCategory',
      name: `${pre}scmCategory`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链分类设置',
        head: true,
        funcID: 'T000501',
        PID: 'T00'
      },
      component: () => import('@/views/digital/resourceManagement/scm/category')
    },
    {
      path: 'scm/scmDictionary',
      name: `${pre}scmDictionary`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链属性设置',
        head: true,
        funcID: 'T000502',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/scm/dictionary')
    },
    {
      path: 'scm/scmInputTemplate',
      name: `${pre}scmInputTemplate`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链录入模板设置',
        head: true,
        funcID: 'T000503',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/scm/inputTemplate')
    },
    {
      path: 'scm/scmAppraisalItem',
      name: `${pre}scmAppraisalItem`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链评估指标',
        head: true,
        funcID: 'T000504',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/scm/appraisalItem')
    },
    {
      path: 'scm/scmTag',
      name: `${pre}scmTag`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链标签设置',
        head: true,
        funcID: 'T000505',
        PID: 'T00'
      },
      component: () => import('@/views/digital/resourceManagement/scm/tag')
    },
    {
      path: 'scm/scmInfo',
      name: `${pre}scmInfo`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链资料维护',
        head: true,
        funcID: 'T000506',
        PID: 'T00'
      },
      component: () => import('@/views/digital/resourceManagement/scm/info')
    },
    {
      path: 'scm/scmInfoTemp/:pageType/:scmCode?',
      name: `${pre}scmInfoTemp`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链资料编辑',
        funcID: 'T000506',
        PID: 'T00'
      },
      component: () =>
        import(
          '@/views/digital/resourceManagement/scm/info/components/temp-detail'
        )
    },
    {
      path: 'scm/scmInfoDetail/:scmCode',
      name: `${pre}scmInfoDetail`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链资料查看',
        funcID: 'T000506',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/scm/info/components/view')
    },
    {
      path: 'scm/scmAppraisalBill',
      name: `${pre}scm-appraisalBill`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链评价模板维护',
        head: true,
        funcID: 'T000507',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/resourceManagement/scm/appraisalBill')
    },
    {
      path: 'scm/scmAppraisalBillDetail/:pageType/:appraisalBillCode?',
      name: `${pre}scmAppraisalBillDetail`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链评价模板维护详情',
        funcID: 'T000507',
        PID: 'T00'
      },
      component: () =>
        import(
          '@/views/digital/resourceManagement/scm/appraisalBill/components/main/components/detail'
        )
    }
  ])('resourceManagement-')
}
